module.exports = __webpack_public_path__ + "img/mobile-locked.8dc2564c.png";